export const levelDescriptions = {
  0: '20-ig számolás egyesével',
  1: '0-4-ig kivonás, összeadás (egyesek)',
  2: '0-4-ig kivonás, összeadás (tízesek)',
  3: '0-4-ig kivonás, összeadás (százasok)',
  4: 'Összeadás 0-10 között - 5=3+2, 5=4+1 ismeretében (egyesek)',
  5: 'Összeadás az 5=3+2, 5=4+1 ismeretében (tízesek)',
  6: 'Összeadás a 10=9+1, 10=8+2, 10=7+3 , 10=6+4, 10=5+5 ismeretében (tízesek)',
}

export const exercises = {
  0: [
    {
      id: 0,
      description : '1 + 1 + ...... + 1 = 20',
      solution: '0 + 1 + 1 + 1 + 1+ 1 + 1+ 1 + 1+ 1 + 1+ 1 + 1+ 1 + 1+ 1 + 1+ 1 + 1+ 1 + 1',
      active: false,
    }
  ],
  1: [
    {
      id: 0,
      description : '0 + 2 - 1 = 1',
      solution: '0 + 2 - 1',
      active: false,
    },
    {
      id: 1,
      description : '2 + 1 + 1 = 4',
      solution : '2 + 1 + 1',
      active: false,
    },
    {
      id: 2,
      description : '3 + 1 - 2 = 2',
      solution : '3 + 1 - 2',
      active: false,
    },
    {
      id: 3,
      description : '1 + 3 - 1 = 3',
      solution : '1 + 3 - 1',
      active: false,
    },

  ],
  2: [
    {
      id: 0,
      description : '22 - 11 = 11',
      solution: '22 - 10 - 1',
      active: false,
    },
    {
      id: 1,
      description : '34 - 22 = 12',
      solution: '34 - 20 - 2',
      active: false,
    },
    {
      id: 2,
      description : '11 + 23 = 34',
      solution: '11 + 20 + 3',
      active: false,
    },
    {
      id: 3,
      description : '2 + 12 = 14',
      solution: '2 + 10 + 2',
      active: false,
    },
    {
      id: 4,
      description : '3 + 31 = 34',
      solution: '3 + 30 + 1',
      active: false,
    },
    {
      id: 5,
      description : '23 - 10 = 13',
      solution: '23 - 10',
      active: false,
    },
  ],
  3: [
    {
      id: 0,
      description : '321 + 113 = 434',
      solution: '321 + 100 + 10 + 3',
      active: false,
    },
    {
      id: 1,
      description : '113 + 21 = 134',
      solution: '113 + 20 + 1',
      active: false,
    },
    {
      id: 2,
      description : '144 - 23 = 121',
      solution: '144 - 20 - 3',
      active: false,
    },
  ],
  4: [
    {
      id: 0,
      description : '3 + 2 = 3 + (5 - 3) = 5',
      solution: '3 + 5 - 3',
      active: false,
    },
    {
      id: 1,
      description : '4 + 3 = 4 + (5 - 2) = 7',
      solution: '4 + 5 - 2',
      active: false,
    },
    {
      id: 2,
      description : '4 + 5 = 9',
      solution: '4 + 5',
      active: false,
    },
    {
      id: 3,
      description : '2 + 6 = 2 + (5 + 1) = 8',
      solution: '2 + 5 + 1',
      active: false,
    },
    {
      id: 4,
      description : '5 + 3 = 8',
      solution: '5 + 3',
      active: false,
    },
    {
      id: 5,
      description : '4 + 4 = 4 + (5-1) = 8',
      solution: '4 + 5 - 1',
      active: false,
    },
  ],
  5: [
    {
      id: 0,
      description : '11 + 4 = 11 + (5 - 1) = 15',
      solution: '11 + 5 - 1',
      active: false,
    },
    {
      id: 1,
      description : '13 + 2 = 13 + (5 - 3) = 15',
      solution: '13 + 5 - 3',
      active: false,
    },
    {
      id: 2,
      description : '14 + 1 = 14 + (5 - 4) = 15',
      solution: '14 + 5 - 4',
      active: false,
    },
    {
      id: 3,
      description : '32 + 23 = 32 + (5-3)*10 + (5-2) = 55',
      solution: '32 + 50 - 30 + 5 - 2',
      active: false,
    },
    {
      id: 4,
      description : '45 + 13 = 45 + (5-4)*10 + 3 = 58',
      solution: '45 + 50 - 40 + 3',
      active: false,
    },
  ],
  6: [
    {
      id: 0,
      description : '8 + 8 = 8 + (10-2) = 16',
      solution: '8 + 10 - 2',
      active: false,
    },
    {
      id: 1,
      description : '8 + 5 = 8 + (10-5) = 13',
      solution: '8 + 10 - 5',
      active: false,
    },
    {
      id: 2,
      description : '3 + 9 = 3 + (10-1) = 12',
      solution: '3 + 10 - 1',
      active: false,
    },
    {
      id: 3,
      description : '9 + 6 = 9 + (10-4) = 15',
      solution: '9 + 10 - 4',
      active: false,
    },
    {
      id: 4,
      description : '8 + 7 = 8 + (10-3) = 15',
      solution: '8 + 10 - 3',
      active: false,
    },
  ]
}
